import { compose } from 'redux'
import { connect } from 'react-redux'
import { lifecycle, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import withCheckStoreAndShowStoreLocatorModal from 'components/common/hoc/withCheckStoreAndShowStoreLocatorModal'
import { getHasActiveVehicleStatus } from 'selectors'
import { getLocationPathname } from 'selectors/getPageLocation'
import { createBrandPageLink } from 'helpers/brand-details'
import { generateSchemaDescription, generateSchemaUrl } from 'helpers/SEOSchema'
import { setBvId } from '../actions'
import BOTTireLineDetailsComponent from './BOTTireLineDetails'
import {
  getAllReviews,
  getNestedBVReviews,
  getInventoryCountStateValue
} from 'components/common/hoc/withBazaarVoiceInlineRatings/selectors'
import {
  setFullReviews,
  getInventoryCount,
  clearInventoryCount,
  clearNestedBVReviews
} from 'components/common/hoc/withBazaarVoiceInlineRatings/actions'
import { generateReviewsListForSchema } from 'components/TireLine/helpers.js'

const mapStateToProps = (state, { tireLineDetails: {
  brandName,
  brandId,
  productPrice,
  itemMinPrice,
  itemMaxPrice,
  bvId
}}) => {
  const hasActiveVehicle = getHasActiveVehicleStatus(state)
  const schemaUrl = generateSchemaUrl(getLocationPathname(state))
  const allBVRatings = getAllReviews(state)
  const { average: averageRating = 0, total: totalRatingCount = 0 } = allBVRatings[bvId] || {}
  const nestedReviews = getNestedBVReviews(state)
  const inventoryCount = getInventoryCountStateValue(state)

  return {
    hasActiveVehicle,
    itemMinPrice,
    itemMaxPrice,
    brandDetailsUrl: createBrandPageLink({ brandName, brandId, hasActiveVehicle }),
    schemaUrl,
    offers: productPrice !== '$0.0-$0.0' ?
      {
        '@type': 'AggregateOffer',
        url: schemaUrl,
        priceCurrency: 'USD',
        lowPrice: itemMinPrice,
        highPrice: itemMaxPrice,
        offerCount: inventoryCount || 1,
        availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition'
      } : undefined,
    aggregateRating: totalRatingCount ? {
      '@type': 'AggregateRating',
      ratingValue: averageRating,
      bestRating: 5,
      worstRating: 1,
      ratingCount: totalRatingCount
    } : undefined,
    review: nestedReviews && nestedReviews.length ? generateReviewsListForSchema(nestedReviews) : undefined
  }
}

const withInitialization = lifecycle({
  componentDidMount() {
    const {
      tireLineDetails: {
        bvId,
        externalIds = []
      } = {},
      setBvId,
      setFullReviews,
      getInventoryCount
    } = this.props
    setBvId({ bvId })
    setFullReviews(bvId)
    getInventoryCount({ externalIds })
  },
  componentDidUpdate({ tireLineDetails: { bvId: prevBVId } = {}}) {
    const {
      tireLineDetails: {
        bvId
      } = {},
      setBvId
    } = this.props
    const bvIdChanged = !(bvId === prevBVId)

    if (bvIdChanged) {
      setBvId({ bvId })
    }
  },
  componentWillUnmount() {
    const { clearInventoryCount, clearNestedBVReviews } = this.props

    clearInventoryCount()
    clearNestedBVReviews()
  }
})

const withSEOSchemaProps = withProps(({ tireLineDetails: { benefits = [], features = []} = {}}) =>
  ({ tireLineDescription: generateSchemaDescription(benefits, features) }))

export const BOTTireLineDetails = compose(
  withType({ type: 'BOTTireLineDetails' }),
  connect(mapStateToProps, {
    setBvId,
    setFullReviews,
    getInventoryCount,
    clearInventoryCount,
    clearNestedBVReviews
  }),
  withInitialization,
  withCheckStoreAndShowStoreLocatorModal,
  withSEOSchemaProps
)(BOTTireLineDetailsComponent)
